import { call, put, takeEvery } from 'redux-saga/effects'
import {
  getBoard,
  getBoardMembers,
  updateBoardMemberResponsibility,
} from 'shared/api/board.api'
import {
  BOARD_FETCH_FAILED,
  BOARD_FETCH_REQUESTED,
  BOARD_FETCH_SUCCESS,
  BOARD_MEMBERS_FETCH_FAILED,
  BOARD_MEMBERS_FETCH_SUCCESS,
  BOARD_UPDATE_RESPONSIBILITY_REQUESTED,
  BOARD_UPDATE_RESPONSIBILITY_SUCCESS,
  BOARD_UPDATE_RESPONSIBILITY_FAILED,
} from './actionTypes'
import { BoardActionTypes } from './types'

function* fetchBoard(action: BoardActionTypes): any {
  try {
    const response = yield call(getBoard, action.payload)

    if (!response.data[0])
      throw new Error(
        'Ingen styrer knyttet til denne klienten. Kontakt boligbyggelaget.'
      )

    yield put({
      type: BOARD_FETCH_SUCCESS,
      payload: response.data[0],
    })
  } catch (e) {
    yield put({
      type: BOARD_FETCH_FAILED,
      payload: 'Det skjedde en feil ved uthenting av styret',
    })
  }
}

function* fetchBoardMembers(action: BoardActionTypes): any {
  try {
    const response = yield call(getBoardMembers, action.payload.id)
    yield put({
      type: BOARD_MEMBERS_FETCH_SUCCESS,
      payload: response.data,
    })
  } catch (e) {
    yield put({
      type: BOARD_MEMBERS_FETCH_FAILED,
      payload: 'Det skjedde en feil ved uthenting av styremedlemmer',
    })
  }
}

function* updateResponsibility(action: BoardActionTypes): any {
  try {
    yield call(
      updateBoardMemberResponsibility,
      action.payload.groupId,
      action.payload.assignmentId,
      action.payload.value
    )
    yield put({
      type: BOARD_UPDATE_RESPONSIBILITY_SUCCESS,
      payload: {
        assignmentId: action.payload.assignmentId,
        value: action.payload.value,
      },
    })
  } catch (e) {
    console.log(e)
    yield put({
      type: BOARD_UPDATE_RESPONSIBILITY_FAILED,
      payload:
        'Det skjedde en feil ved oppdatering av ansvarsområde, vennligst prøv igjen',
    })
  }
}

function* boardSaga() {
  yield takeEvery(BOARD_FETCH_REQUESTED, fetchBoard)
  yield takeEvery(BOARD_FETCH_SUCCESS, fetchBoardMembers)
  yield takeEvery(BOARD_UPDATE_RESPONSIBILITY_REQUESTED, updateResponsibility)
}

export default boardSaga
